import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-511dee66"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bus-stops-container" }
const _hoisted_2 = { class: "map-container" }
const _hoisted_3 = { class: "upper-btns" }
const _hoisted_4 = { class: "btns-wrapper" }
const _hoisted_5 = {
  key: 0,
  class: "middle-btns"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock($setup["Page"], null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode($setup["NavigationBar"], { title: "정류장 검색" }),
        _createElementVNode("div", _hoisted_2, [
          ($setup.currentLat && $setup.currentLng)
            ? (_openBlock(), _createBlock($setup["NaverMap"], {
                key: 0,
                ref: "naverMap",
                latitude: $setup.addressLatitude,
                longitude: $setup.addressLongitude,
                busStops: $setup.filteredBusStops,
                circleRadiusMeter: $setup.radiusMeter,
                showCurrentLocation: !$props.targetBusStopId,
                selectedBusStop: $setup.selectedBusStop,
                zoomLevel: $setup.zoomLevel,
                minZoomLevel: $setup.MIN_ZOOM_LEVEL,
                maxZoomLevel: $setup.MAX_ZOOM_LEVEL,
                useCluster: false,
                shouldShowPositionMarker: true,
                infoWindowContent: $setup.infoWindowContent,
                onOnSelectedBusStopMarker: $setup.showBusStopInfo,
                onOnChangedMapCenter: $setup.handleMapCenterChanged,
                onOnMapIdle: $setup.handleMapIdle,
                onOnDragEndMap: $setup.markUpdateNeeded,
                onOnZoomChanged: $setup.updateZoomLevel
              }, null, 8 /* PROPS */, ["latitude", "longitude", "busStops", "circleRadiusMeter", "showCurrentLocation", "selectedBusStop", "zoomLevel", "infoWindowContent"]))
            : _createCommentVNode("v-if", true)
        ]),
        _createVNode($setup["AddressSearch"], {
          ref: "addressSearch",
          class: _normalizeClass([
          'address-search-wrapper',
          { 'has-results': $setup.hasSearchResults },
          { 'line-info-list-visible': $setup.lineInfoListVisibility },
        ]),
          searchKeyword: $setup.searchKeyword,
          onOnChangedSearchKeyword: $setup.updateSearchKeyword,
          onOnSelectedAddress: $setup.updateSelectedAddress,
          onOnSearchResultsChanged: $setup.updateSearchResultsStatus
        }, null, 8 /* PROPS */, ["class", "searchKeyword"]),
        _createElementVNode("section", _hoisted_3, [
          _createElementVNode("div", null, [
            _createVNode($setup["MapLineTypeFilter"], {
              class: "line-type-filter",
              onOnChangedLineTypeCheckedMap: $setup.updateCheckedLineTypesCodes
            })
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createVNode($setup["MapZoomLevelSetter"], {
              class: "zoom-level",
              zoomLevel: $setup.zoomLevel,
              maxZoomLevel: $setup.MAX_ZOOM_LEVEL,
              minZoomLevel: $setup.MIN_ZOOM_LEVEL,
              onZoomIn: $setup.updateZoomLevel,
              onZoomOut: $setup.updateZoomLevel
            }, null, 8 /* PROPS */, ["zoomLevel"]),
            _createElementVNode("button", {
              class: _normalizeClass(["street-view-btn-wrapper", { disabled: !$setup.selectedBusStop }]),
              type: "button",
              "aria-label": "거리뷰 보기",
              onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.toggleShowStreetView(true)))
            }, [
              _createVNode($setup["InlineSvg"], {
                class: "img-street-view-btn",
                src: require('@/assets/icons/street-view.svg'),
                alt: "거리뷰 보기",
                "aria-hidden": "true"
              }, null, 8 /* PROPS */, ["src"])
            ], 2 /* CLASS */),
            _createElementVNode("button", {
              class: "gps-btn-wrapper",
              type: "button",
              "aria-label": "내 위치로 이동",
              onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.moveMapToCenter($setup.currentLat, $setup.currentLng))),
              style: _normalizeStyle($setup.gpsButtonStyle)
            }, [
              _createVNode($setup["InlineSvg"], {
                class: "img-gps-btn",
                src: require('@/assets/icons/gps.svg'),
                alt: "내 위치로 이동",
                "aria-hidden": "true"
              }, null, 8 /* PROPS */, ["src"])
            ], 4 /* STYLE */)
          ])
        ]),
        ($setup.windowHeight > 667 && $setup.filteredBusStops.length)
          ? (_openBlock(), _createElementBlock("section", _hoisted_5, [
              _createElementVNode("button", {
                class: "left-stop-btn-wrapper",
                type: "button",
                "aria-label": "이전 정류장 보기",
                onClick: $setup.movePreviousBusStop
              }, [
                _createVNode($setup["InlineSvg"], {
                  class: "img-left-btn",
                  src: require('@/assets/icons/chevron-left-medium.svg'),
                  alt: "이전 정류장 보기",
                  "aria-hidden": "true"
                }, null, 8 /* PROPS */, ["src"])
              ]),
              _createElementVNode("button", {
                class: "right-stop-btn-wrapper",
                type: "button",
                "aria-label": "다음 정류장 보기",
                onClick: $setup.moveNextBusStop
              }, [
                _createVNode($setup["InlineSvg"], {
                  class: "img-right-btn",
                  src: require('@/assets/icons/chevron-right-medium.svg'),
                  alt: "다음 정류장 보기",
                  "aria-hidden": "true"
                }, null, 8 /* PROPS */, ["src"])
              ])
            ]))
          : _createCommentVNode("v-if", true),
        ($setup.windowHeight >= 667)
          ? (_openBlock(), _createBlock($setup["RadiusSlider2"], {
              key: 1,
              class: "radius-slider",
              radiusMeterList: $setup.radiusMeterList,
              initialRadiusIndex: 0,
              height: "135px",
              onOnChangeRadiusMeter: $setup.updateRadiusMeter
            }))
          : _createCommentVNode("v-if", true),
        ($setup.filteredBusStops.length)
          ? (_openBlock(), _createBlock($setup["MapOfNearbyBusStopsBottomSheet"], {
              key: 2,
              ref: "bottomSheetModal",
              busStops: $setup.filteredBusStops,
              selectedBusStop: $setup.selectedBusStop!,
              updateKey: $setup.updateKey,
              lineInfos: $setup.lineInfos,
              maxHeightPx: $setup.maxHeightPx,
              onOnSlideChange: $setup.updateSelectedBusStopFromSlider,
              onOnChangedShowLineInfoList: $setup.updateShowLineInfoListVisibility
            }, null, 8 /* PROPS */, ["busStops", "selectedBusStop", "updateKey", "lineInfos", "maxHeightPx"]))
          : _createCommentVNode("v-if", true)
      ]),
      _createVNode($setup["PageModal"], {
        shouldShow: $setup.shouldShowStreetView,
        onBackHandler: () => $setup.toggleShowStreetView(false)
      }, {
        default: _withCtx(() => [
          _createVNode($setup["BusStopStreetView"], {
            title: $setup.selectedBusStop?.name,
            latitude: $setup.selectedBusStop?.latitude ?? $setup.addressLatitude,
            longitude: $setup.selectedBusStop?.longitude ?? $setup.addressLongitude,
            onOnClickClose: _cache[2] || (_cache[2] = ($event: any) => ($setup.toggleShowStreetView(false)))
          }, null, 8 /* PROPS */, ["title", "latitude", "longitude"])
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["shouldShow", "onBackHandler"])
    ]),
    _: 1 /* STABLE */
  }))
}